<template>
  <div>
    <header-page :title="title" showCiudadSelector @update="ActionGetAueObjectives()"  />
    <div
      :class="[
        'container aue-container',
        showIndicadores ? 'aue-container-indicadores' : '',
      ]"
    >
      <Breadcrumbs />
      <div class="row">
        <div class="title-container">
          <q-img
            :src="require(`@/assets/img/agendaurbana.png`)"
            class="Imagen"
            width="105px"
            height="105px"
            contain
          />
          <h5 class="title">Agenda Urbana Española</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 dBtn">
          <q-btn
            data-cy="saveAue"
            unelevated
            class="bPrincipal"
            :icon="'img:' + require('@/assets/img/save.svg')"
            label="GUARDAR CAMBIOS"
            @click="saveData()"
            :loading="isLoadingSave"
            :disable="ciudadSelected === null"
          />
        </div>
      </div>
      <q-card>
        <div class="row col-12">
          <div
            :class="['row q-col-gutter-sm', showIndicadoresClass]"
            style="display: flex; justify-content: space-between"
          >
            <div :class="showIndicadoresClassItems">
              <div
                class="box-container col-sm-12 col-md-6"
                v-for="i in 5"
                v-bind:key="i"
              >
                <Contenedor
                  adminMode
                  :showConsecucionObjetivo="false"
                  :datos="aue[i - 1]"
                  :ciudadIndice="getCityData(aue[i - 1])"
                  v-on:activeObjetivo="activarObjetivo($event)"
                  @updateVisibility="refreshObjetivoVisibility"
                />
              </div>
            </div>
            <div :class="showIndicadoresClassItems">
              <div :class="['container-objetivos']">
                <div
                  class="box-container col-sm-12 col-md-6"
                  v-for="i in 5"
                  v-bind:key="i"
                >
                  <Contenedor
                    adminMode
                    :showConsecucionObjetivo="false"
                    :datos="aue[i + 4]"
                    :ciudadIndice="getCityData(aue[i + 4])"
                    v-on:activeObjetivo="activarObjetivo($event)"
                    @updateVisibility="refreshObjetivoVisibility"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-7 container-indicadores">
            <ListadoIndicadores
              v-if="showIndicadores"
              :indicadoresSelected="indicadores"
              @refreshSelectedItems="refreshSelectedIndicadores"
              showSelection
            />
          </div>
        </div>
      </q-card>
    </div>
  </div>
</template>

<script>
import Utils from '@/components/shared/helpers/Utils.js';
import Contenedor from '@/components/Aue/components/Objetivo.vue';
import Message from '@/components/shared/mixins/Message.js';
import ListadoIndicadores from '@/components/Indicadores/components/AdminListado.vue';
import { QImg, QCard } from 'quasar';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import Const from '@/components/shared/helpers/Const.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  mixins: [Message],
  components: {
    Contenedor,
    ListadoIndicadores,
    QImg,
    HeaderPage,
    QCard,
    Breadcrumbs
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      aue: types.ALL_AUEOBJETIVES,
      aueCity: types.AUEOBJETIVE_CIUDAD,
      AUESelected: types.AUE_SELECTED
    })
  },
  data () {
    return {
      showIndicadores: false,
      showIndicadoresClass: 'col-12',
      showIndicadoresClassItems: 'col-6',
      objetivos: [],
      indicadores: [],
      title: 'ADMINISTRACIÓN',
      isLoadingSave: false
    };
  },
  async created () {
    if (this.ciudadSelected !== null) {
      if (this.ciudadSelected.indices.indexOf(Const.ID_AUE) === -1) {
        this.$router.push({ name: 'inicio' });
      }

      // Empty State of AUE Selected
      this.$store.commit(types.MUTATE_AUE_SELECTED, null);

      await this.$store.dispatch(types.ACTION_GET_ALL_AUEOBJETIVES).then(async response => { this.ActionGetAueObjectives(); }).catch();
    }
  },
  watch: {
    ciudadSelected () {
      if (this.ciudadSelected.indices.indexOf(Const.ID_AUE) === -1) this.$router.push({ name: 'inicio' });
    }
  },
  mounted () {
    // Borramos la seleccción
    this.removeSelected();
    // Escuchamos desde metas
    this.$eventHub.$on('open_indicadores', (o) => {
      this._goToTop();

      let objetivo = o.objetivo;
      this.$store.state.NGUD.Aue.selected = o;
      this.changeOrder(objetivo);

      this.showIndicadoresClass = 'col-5';
      this.showIndicadoresClassItems = 'col-12';
      this.showIndicadores = true;

      this.indicadores = o.indicadores;
    });

    this.$eventHub.$on('close_indicadores', () => {
      this.delayAnimationWidth();
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('open_indicadores');
    this.$eventHub.$off('close_indicadores');
  },
  methods: {
    _goToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    async ActionGetAueObjectives () {
      this.delayAnimationWidth();
      await this.$store.dispatch(types.ACTION_GET_AUEOBJETIVE_CIUDAD).then().catch();
    },
    removeSelected () {
      this.$store.state.NGUD.Aue.selected = {};
      this.$store.commit(types.MUTATE_AUE_SELECTED, null);
    },
    delayAnimationWidth () {
      setTimeout(() => {
        this.showIndicadoresClass = 'col-12';
        this.showIndicadoresClassItems = 'col-6';
      }, 700);
      this.showIndicadores = false;
      this.removeSelected();
    },
    changeOrder (idObjetivo) {
      const index = this.aue.findIndex(e => e.id === idObjetivo);
      const aux = Utils.moveArray(this.aue, index, 0);
      this.orderObjetivos(aux);
    },
    activarObjetivo (selectedId) {
      if (selectedId === this.AUESelected) return this.$store.commit(types.MUTATE_AUE_SELECTED, null);
      this.$store.commit(types.MUTATE_AUE_SELECTED, selectedId);
    },
    orderObjetivos (data) {
      // Nos guardamos el primer valor para no ordenarlo.
      let auxFirstElement = data[0];
      data.splice(0, 1);
      let sortData = data;

      sortData.sort((a, b) => {
        return a.order - b.order;
      });

      sortData.splice(0, 0, auxFirstElement);

      return sortData;
    },
    getCityData (dataObjetivo) {
      let returnData = {};
      let idObjetivo = dataObjetivo.id;

      this.aueCity.map(e => {
        if (e.id === idObjetivo) returnData = e;
      });
      return returnData;
    },
    refreshSelectedIndicadores (indicadores) {
      let metaPosition = this.$store.state.NGUD.Aue.selected.metaPosition;
      this.aueCity.map((n) => { if (n.id === this.AUESelected) { n.metas[metaPosition].indicadores = indicadores.selected.map((v) => { return { id: v.id }; }); } });
    },
    refreshObjetivoVisibility (data) {
      this.aueCity.map((n) => { if (n.id === data.idObj) { n.visible = data.visibility; } });
    },
    saveData () {
      this.isLoadingSave = true;

      this.$store.dispatch(types.ACTION_SAVE_AUEOBJETIVE_CIUDAD, { data: this.aueCity }).then(() => { this.showMessage('Actualizado con éxito.'); this.isLoadingSave = false; }).catch(() => { this.isLoadingSave = false; });
    }
  }
};
</script>

<style lang="scss" scoped>
.aue-container-indicadores {
  padding-right: 33px !important;
  transition: padding 1s;
}
.aue-container {
  transition: padding 1s;
  color: #003f87 !important;
  font-family: DINPro;
  .bPrincipal {
    float: right;
  }
  .dBtn {
    margin-bottom: 15px;
  }
  &::v-deep {
    .q-card {
      box-shadow: none;
    }
  }

  .title-city {
    padding-top: 40px;
    font-family: DINPro;
    font-size: 35px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -1.41px;
    color: #002f6c;
  }
  .title-container {
    display: flex;
    .title {
      padding-left: 10px;
      margin: auto;
      text-transform: uppercase;
      font-family: DINPro;
      font-size: 29px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -1.17px;
      color: #042857;
    }
  }
  padding-right: 100px;
  .box-container {
    padding-bottom: 40px;
  }

  .container-indicadores {
    padding-left: 36px;
  }
}

@media screen and (max-width: 599px) {
  .aue-container {
    padding: 0;
    margin-left: 10px;
    .box-container {
      padding-right: 8px;
    }
    .title {
      font-size: 26px;
    }
  }
}

@media screen and (max-width: 440px) {
  .aue-container {
    .box-container {
      margin-left: 0px;
      margin-right: 0px;
      padding-right: 0px;
      padding-left: 0px;
    }
  }
}
</style>
